<template>
  <div class=" is-fullwidth">
    
    <div class="is-pulled-right"><input class="input" v-model="search" placeholder="search orders ..."/></div>
    
    <table class="table is-hoverable is-fullwidth is-size-7" id="orderstable">
    	<thead>
    		<th width="60">&nbsp;</th>
        <th @click="updateSortOrder('ponumber')" style="cursor:pointer">PO Number
            <span v-if="order_by === 'ponumber DESC'">&#8595;</span>
            <span v-if="order_by === 'ponumber ASC'">&#8593;</span>
          </th>
   	 		<th @click="updateSortOrder('clientname')" style="cursor:pointer">Customer
            <span v-if="order_by === 'clientname DESC'">&#8595;</span>
            <span v-if="order_by === 'clientname ASC'">&#8593;</span>
          </th>
          <th @click="updateSortOrder('garmentname')" style="cursor:pointer">Garment
            <span v-if="order_by === 'garmentname DESC'">&#8595;</span>
            <span v-if="order_by === 'garmentname ASC'">&#8593;</span>
          </th>
          <th>Range</th>
          <th @click="updateSortOrder('deliverydate')" style="cursor:pointer">Delivery
            <span v-if="order_by === 'deliverydate DESC'">&#8595;</span>
            <span v-if="order_by === 'deliverydate ASC'">&#8593;</span>
          </th>
          <th>Qty</th>
          <th width="110">&nbsp;</th>
          <th width="150">&nbsp;</th>
          <th width="130">&nbsp;</th>
          <th width="105">&nbsp;</th>
    	</thead>
    	<tbody>
		    <tr v-if="loading === true">
                <td colspan="11" ><div class="notification is-info">Loading orders ...</div></td>
            </tr>
            <tr v-if="loading == false && filteredOrders.length == 0">
                <td colspan="11" ><div class="notification is-warning">There are no orders to show</div></td>
            </tr>
            
            <tr v-for="order in filteredOrders" v-bind:key="order.orderID">
         <td >
                  <a :href="ASP_URL + '/printorder.asp?txtPONumber=' + order.ponumber" target="_blank"><button class="button is-small is-info" :disabled="working===true" >Print</button></a>
              </td>
               <td >{{order.ponumber}}</td>
          <td>{{order.clientname}}</td>
          <td>{{order.garmentname}} <span class="tag is-warning" v-if="order.requires_embroidery == 1" title="Embroidery selected on CAD Upload">E</span></td>
          <td>{{order.range_name}}</td>
          <td>{{order.deliverydate}}</td>
          <td>{{ order.total_qty }}</td>
          <td ><button class="button is-small" :disabled="working==true" @click="setNotRequired(order)" :class="{'is-warning' : order.order_embroidery === 0}">No Emb.</button></td>
          <td><button class="button is-small " :disabled="working==true" @click="setRequired(order)" :class="{'is-success' : order.order_embroidery === 1}">Emb. Required</button></td>
          <td><button class="button is-small is-link" :disabled="working==true" @click="showEmbroideryModal(order)" v-if="order.order_embroidery===1">Add Details</button></td>
          <td><button class="button is-small is-success" :disabled="working==true" @click="processOrder(order)" v-if="order.order_embroidery===1 || order.order_embroidery===0">Process</button></td>
          
          
              
			</tr>
    	</tbody>
    </table>
    
    <EmbroideryModal :showModal="showModal" @closeModal="showModal=false" :orderID="selectedOrderID"  :showAddButtons="showAddButtons"/>
    
    
  </div>
</template>

<script>
import EmbroideryModal from '@/components/Offshore/EmbroideryModal';

import OrderService from '@/services/OrderService.js';
//import UtilityService from '@/services/UtilityService.js';

import OrderMixin from "@/mixins/OrderMixin.js";

export default {
  components: {
    EmbroideryModal
  },
  mixins: [OrderMixin],
  data() {
    return {
       errors: [],
      orders: [],
      showModal: false,
      selectedOrderID: 0,
      working :false,
      loading: true,
      ASP_URL : process.env.VUE_APP_ASP_URL,
      ranges: [],
      makeuplocations: [],
      order_by: 'deliverydate ASC',
      makeup_location_id: '',
      showAddButtons: true,
      accessToken: '',
      search:''
    }
  },
   methods: {
    showEmbroideryModal(order) {
      this.selectedOrderID = order.orderID
     
        this.showModal = true
    },
      async getOrders() {
        this.loading=true
        this.orders = []
        OrderService.getOffshoreEmbroideryOrders(this.accessToken, this.order_by, 0, 0, 0, 1) // embroidery_processed, in production, sent offshore
        .then(
          (orders => {
            this.$set(this, "orders", orders);
            this.loading=false
          }).bind(this)
        );
      },
      async setRequired(order) {
       if(order.order_embroidery === 0 || order.order_embroidery === null)
        {
          this.working = true

          var formdata = { 
            _method: 'patch',
            order_embroidery: 1
          }; 

          OrderService.updateOrder(this.accessToken, order.orderID, formdata)
            .then(() => {
            order.order_embroidery = 1
            this.working = false
            //console.log(response)
          }).catch((error) => {
            alert("Something went wrong and the order has not been updated. Please reload and try again")
            console.log("Error:" + JSON.stringify(error.response.data));
            this.working = false
          });
        }
      },
      async setNotRequired(order) {
       if(order.order_embroidery === 1 || order.order_embroidery === null)
        {
          this.working = true

          var formdata = { 
            _method: 'patch',
            order_embroidery: 0
          }; 

          OrderService.updateOrder(this.accessToken, order.orderID, formdata)
            .then(() => {
            order.order_embroidery = 0
            this.working = false
            //console.log(response)
          }).catch((error) => {
            alert("Something went wrong and the order has not been updated. Please reload and try again")
            console.log("Error:" + JSON.stringify(error.response.data));
            this.working = false
          });
        }
      },
      async processOrder(order) {
       if(order.order_embroidery === 1 || order.order_embroidery === 0)
        {
          this.working = true

          if(confirm("Are you sure you want to move this order on ? Please make sure you have entered all embroidery and initials via the blue button."))
          {
            var formdata = { 
              _method: 'patch',
              embroidery_processed: 1
            }; 

            OrderService.updateOrder(this.accessToken, order.orderID, formdata)
              .then(() => {
              order.embroidery_processed = 1
              this.working = false
              //console.log(response)
            }).catch((error) => {
              alert("Something went wrong and the order has not been updated. Please reload and try again")
              console.log("Error:" + JSON.stringify(error.response.data));
              this.working = false
            });
          }
          else{
            this.working = false
            return false
          }

          
        }
      },
      
    
   
    
  },
  computed : {
      filteredOrders: function () {
       
        let filteredOrders =  this.orders.filter(function(u) { 
            if(  u.embroidery_processed == 0) 
            {
              return 1
            }
          })
          
          if(this.search != '' && this.search != null)
         {
           filteredOrders = filteredOrders.filter(row => 
           row.ponumber.toLowerCase().includes(this.search.toLowerCase())
            || row.clientname.toLowerCase().includes(this.search.toLowerCase())
            || row.garmentname.toLowerCase().includes(this.search.toLowerCase())
            )
         }

          return filteredOrders
       
     }

    
  },

  // Fetches posts when the component is created.
  created() {
     this.getAccessToken()
        .then(() => { 
           this.getOrders();
           
        });
  },
 
  mounted() {
    /*if (localStorage.production_allocated_makeup_location_id) {
      this.makeup_location_id = localStorage.production_allocated_makeup_location_id;
    }
    else{
      this.makeup_location_id = 5
    }*/
      
  },
  watch: {
   /* makeup_location_id: function () {
      localStorage.production_allocated_makeup_location_id = this.makeup_location_id
      if(this.accessToken != "")
      {
        this.getOrders()
      }
    },*/
  }
}


</script>

